import { formatDate, getDateByTimeZone } from "@/lib/date";

import {
  SIZE_TYPE_150_HANJIN,
  SIZE_TYPE_150_V3,
  SIZE_TYPE_150_V3_BLANK,
} from "@/utils/Print";

import {
  DELIVERY_TYPE_NORMAL,
  DELIVERY_TYPE_RETURN,
  DELIVERY_TYPE_PICKUP,
  DELIVERY_STATUS_0,
  DELIVERY_STATUS_9,
} from "@/Models/Delivery";

export const CORP_USER_NAMES_KOOKMIN = "kb9597";

export const SPOT_CODE_10128 = "10128"; // 두손컴퍼니
export const SPOT_CODE_10129 = "10129"; // 두손컴퍼니
export const SPOT_CODE_10130 = "10130"; // 두손컴퍼니
export const SPOT_CODE_10220 = "10220"; // 두손컴퍼니

export const SPOT_CODE_10191 = "10191"; // 에프엠제이
export const SPOT_CODE_10195 = "10195"; // 에프엠제이
export const SPOT_CODE_10196 = "10196"; // 에프엠제이
export const SPOT_CODE_10197 = "10197"; // 에프엠제이
export const SPOT_CODE_10198 = "10198"; // 에프엠제이

export const SPOT_CODE_10101 = "10101";
export const SPOT_CODE_10111 = "10111"; // 스테이지파이브
export const SPOT_CODE_10170 = "10170"; // 힙핑크
export const SPOT_CODE_10184 = "10184"; // 패션풀
export const SPOT_CODE_10190 = "10190"; // SK텔링크
export const SPOT_CODE_10193 = "10193"; // 배상면주가
export const SPOT_CODE_10209 = "10209"; // 데싱디바
export const SPOT_CODE_10212 = "10212"; // 딜리셔스
export const SPOT_CODE_10240 = "10240"; // 플라이북
export const SPOT_CODE_10241 = "10241"; // LG헬로모바일
export const SPOT_CODE_10276 = "10276"; // 쿠마이츠
export const SPOT_CODE_10279 = "10279"; // 노원 비대면 진약국
export const SPOT_CODE_10282 = "10282"; // 노원구 재택치료 격리관리반
export const SPOT_CODE_10063 = "10063"; // 미디어로그(U+유모바일(후불))
export const SPOT_CODE_10644 = "10644"; // 미디어로그(U+유모바일(선불))
export const SPOT_CODE_10643 = "10643"; // 미디어로그(U+유모바일(추천))
export const SPOT_CODE_10506 = "10506"; // 컬리
export const SPOT_CODE_10491 = "10491"; // ayoung
export const SPOT_CODE_10569 = "10569"; // air 고객센터(sktelecom)
export const SPOT_CODE_10695 = "10695"; // 간편유심(sktmvno)

export const SPOT_CODE_10480 = "10480"; // 한진
export const SPOT_CODE_10517 = "10517"; // 우리술컴퍼니

export const SPOT_CODE_10546 = "10546"; // 에이치에스에이치

export const SPOT_CODE_10585 = "10585"; // CJ 더마켓

export const SPOT_CODE_P0015 = "P0015"; // 찍스

export const SPOT_CODE_10580 = "10580"; // 다은상회

export const SPOT_CODE_10558 = "10558"; // 커버링

export const SPOT_CODE_82005 = "82005"; // 꾸까

export const SPOT_CODE_82002 = "82002"; // 다이얼커뮤니케이션즈

export const SPOT_CODE_10715 = "10715"; // 어글리랩

export const SPOT_CODE_10278 = "10278"; // 떡함지

const MM_TO_PX = 3.7795275591; // 96dpi 기준

function getCanvasContext() {
  if (!getCanvasContext._ctx) {
    const canvas = document.createElement("canvas");
    getCanvasContext._ctx = canvas.getContext("2d");
  }
  return getCanvasContext._ctx;
}

// 한 상품명이 몇 줄을 차지하는지 추정
function estimateLineCount(text, { fontSize, fontWeight = "bold", widthMm }) {
  const ctx = getCanvasContext();
  ctx.font = `${fontWeight} ${fontSize}px sans-serif`; // 실제 라벨에 쓰는 폰트로 맞춰주세요
  const widthPx = widthMm * MM_TO_PX;
  const textWidthPx = ctx.measureText(text).width;
  return Math.max(1, Math.ceil(textWidthPx / widthPx));
}

// 상품명 배열을 "줄수 기준"으로 first/rest 분리
function splitProductNamesByLines(productNamesArr, maxLines, styleOptions) {
  let usedLines = 0;
  let cutIndex = productNamesArr.length;

  for (let i = 0; i < productNamesArr.length; i++) {
    const name = productNamesArr[i];
    const fullName = Array.isArray(name) ? name.join("") : name;
    const lines = estimateLineCount(fullName, styleOptions);

    if (usedLines + lines > maxLines) {
      cutIndex = i;
      break;
    }
    usedLines += lines;
  }

  return {
    first: productNamesArr.slice(0, cutIndex),
    rest: productNamesArr.slice(cutIndex),
  };
}

export class DeliveryForWaybill {
  addressNotSupported = false;

  bookId = null;

  corpUser = null;

  customerAddressError = false;

  etc2 = "";
  etc4 = "{}";

  memoFromCustomer = null;

  orderIdFromCorp = null;

  productCountOld = null;
  productName = null;

  receiptDate = null;

  receiverAddress = null;
  receiverAddressDetail = null;
  receiverPostalCode = null;
  receiverAddressRoad = null;
  receiverAllocationGroupName = null;
  receiverDong = null;
  receiverSigungu = null;
  receiverSido = null;
  receiverName = null;
  receiverMobile = null;
  receiverMobile2 = null;
  receiverInputAddress = null;

  region = null;

  senderAddress = null;
  senderAddressDetail = null;
  senderAddressError = false;
  senderPostalCode = null;
  senderAddressRoad = null;
  senderAllocationGroupName = null;
  senderName = null;
  senderMobile = "";
  senderInputAddress = null;

  status = DELIVERY_STATUS_0;

  spot = null;

  type = DELIVERY_TYPE_NORMAL;

  unrefinedAddress = null;

  constructor(delivery, sizeType) {
    this.addressNotSupported = delivery.addressNotSupported;

    this.bookId = delivery.bookId;

    this.corpUser = delivery.corpUser;

    this.customerAddressError = delivery.customerAddressError;

    this.etc1 = delivery.etc1;
    this.etc2 = delivery.etc2;
    this.etc4 = delivery.etc4;

    this.memoFromCustomer = delivery.memoFromCustomer;

    this.orderIdFromCorp = delivery.orderIdFromCorp;
    this.orderIdFromCorpSub = delivery.orderIdFromCorpSub;

    this.productCountOld = delivery.productCount || delivery.productCountOld;
    this.productName = delivery.productName?.trim() || "";

    this.receiptDate = delivery.receiptDate;

    this.receiverAddress = delivery.receiverAddress;
    this.receiverAddressDetail = delivery.receiverAddressDetail;
    this.receiverPostalCode = delivery.receiverPostalCode;
    this.receiverAddressRoad = delivery.receiverAddressRoad;
    this.receiverAllocationGroupName = delivery.receiverAllocationGroupName;
    this.receiverDong = delivery.receiverDong || delivery.receiverDongObj;
    this.receiverSigungu =
      (delivery.receiverDong && delivery.receiverDong.sigungu) ||
      (delivery.receiverDongObj && delivery.receiverDongObj.sigungu) ||
      null;
    this.receiverSido =
      (this.receiverSigungu && this.receiverSigungu.sido) || null;
    this.receiverName = delivery.receiverName;
    this.receiverMobile = delivery.receiverMobile;
    this.receiverMobile2 = delivery.receiverMobile2;
    this.receiverInputAddress = delivery.receiverInputAddress;

    this.region = delivery.region;

    this.senderAddress = delivery.senderAddress;
    this.senderAddressDetail = delivery.senderAddressDetail;
    this.senderAddressError = delivery.senderAddressError;
    this.senderPostalCode = delivery.senderPostalCode;
    this.senderAddressRoad = delivery.senderAddressRoad;
    this.senderAllocationGroupName = delivery.senderAllocationGroupName;
    this.senderName = delivery.senderName;
    this.senderMobile = delivery.senderMobile;
    this.senderInputAddress = delivery.senderInputAddress;

    this.status = delivery.status;

    this.sizeType = sizeType;

    this.spot = delivery.spot;

    this.type = delivery.type || DELIVERY_TYPE_NORMAL;

    this.unrefinedAddress = delivery.unrefinedAddress;
  }

  get corpUserEtc() {
    return this.corpUser?.etc;
  }

  get corpUserEtcObj() {
    try {
      return this.corpUserEtc && JSON.parse(this.corpUserEtc);
    } catch (e) {
      return {};
    }
  }

  get customerAddress() {
    if (this.type === DELIVERY_TYPE_RETURN) {
      return this.returnPickupEtc4Obj
        ? this.returnPickupEtc4Obj.customerAddress &&
          this.returnPickupEtc4Obj.customerAddress !== "undefined"
          ? this.returnPickupEtc4Obj.customerAddress
          : this.senderAddress
        : "";
    } else {
      return this.etc4Obj?.customerAddress || "";
    }
  }

  get customerAddressDetail() {
    if (this.type === DELIVERY_TYPE_RETURN) {
      return this.returnPickupEtc4Obj
        ? this.returnPickupEtc4Obj.customerAddress &&
          this.returnPickupEtc4Obj.customerAddress !== "undefined"
          ? this.returnPickupEtc4Obj.customerAddressDetail
          : this.senderAddressDetail
        : "";

      // return this.returnPickupEtc4Obj
      //   ? this.returnPickupEtc4Obj.customerAddressDetail
      //   : "";
    } else {
      return this.etc4Obj?.customerAddressDetail || "";
    }
  }

  get displayCorpLogoImageObjBySpotCode() {
    switch (this.spotCode) {
      case SPOT_CODE_10191:
      case SPOT_CODE_10193:
      case SPOT_CODE_10195:
      case SPOT_CODE_10196:
      case SPOT_CODE_10197:
      case SPOT_CODE_10198:
        if (this.corpUser && this.corpUser.logoImage) {
          return JSON.parse(this.corpUser.logoImage);
        } else {
          return null;
        }
      default:
        return null;
    }
  }

  get displayOrderIdFromCorpBySpotCode() {
    switch (this.spotCode) {
      case SPOT_CODE_10111:
      case SPOT_CODE_10170:
      case SPOT_CODE_10184:
        return this.orderIdFromCorp;
      default:
        return null;
    }
  }

  get displayReceiverAddressWithoutSigungu() {
    switch (this.spotCode) {
      case SPOT_CODE_10480:
      case SPOT_CODE_10517:
        if (
          this.addressNotSupported ||
          this.status === DELIVERY_STATUS_9 ||
          !!this.customerAddressError
        ) {
          return "확인 필요";
        } else {
          const addressArr =
            this.receiverAddressWithoutSigungu?.split(" ") || [];

          return (
            (addressArr[0] || "") +
            (addressArr?.length > 2 ? ` ${addressArr[1]}` : "") +
            "****"
          );
        }
      default:
        if (this.useMasking) {
          const addressArr =
            this.receiverAddressWithoutSigungu?.split(" ") || [];

          return (
            (addressArr[0] || "") +
            (addressArr?.length > 2 ? ` ${addressArr[1]}` : "") +
            "****"
          );
        } else {
          return this.receiverAddressWithoutSigungu;
        }
    }
  }

  get displayReceiverAddressRoadWithoutSigungu() {
    switch (this.spotCode) {
      case SPOT_CODE_10480:
      case SPOT_CODE_10517:
        if (
          this.addressNotSupported ||
          this.status === DELIVERY_STATUS_9 ||
          !!this.customerAddressError
        ) {
          return "확인 필요";
        } else {
          return this.receiverAddressRoadWithoutSigungu;
        }
      default:
        return this.receiverAddressRoadWithoutSigungu;
    }
  }

  get displayReceiverBuilding() {
    switch (this.spotCode) {
      case SPOT_CODE_10480:
      case SPOT_CODE_10517:
      case SPOT_CODE_10546:
        if (
          this.addressNotSupported ||
          this.status === DELIVERY_STATUS_9 ||
          !!this.customerAddressError
        ) {
          return "";
        } else {
          return "***";
        }
      default:
        return this.receiverBuilding;
    }
  }

  get displayReceiverAddressDetail() {
    if (
      this.receiverAddressDetail &&
      this.receiverAddressDetail.indexOf(this.receiverAddress) > -1
    ) {
      return this.receiverAddressDetail.slice(this.receiverAddress.length);
    } else {
      return this.receiverAddressDetail;
    }
  }

  get displayReceiverMobile() {
    switch (this.sizeType) {
      default:
        switch (this.spotCode) {
          case SPOT_CODE_10128:
          case SPOT_CODE_10129:
          case SPOT_CODE_10130:
          case SPOT_CODE_10220:
          case SPOT_CODE_10212:
          case SPOT_CODE_10282:
          case SPOT_CODE_10279:
          case SPOT_CODE_10240:
          case SPOT_CODE_10063:
          case SPOT_CODE_10506:
          case SPOT_CODE_10491:
          case SPOT_CODE_10480:
          case SPOT_CODE_10517:
          case SPOT_CODE_10546:
            return `${
              this.receiverMobile
                ? `${this.receiverMobile.slice(0, -4)}****`
                : ""
            }${
              this.receiverMobile2
                ? ` /${this.receiverMobile2.slice(0, -4)}****`
                : ""
            }`;
          default:
            if (this.useMasking) {
              return `${
                this.receiverMobile
                  ? `${this.receiverMobile.slice(0, -4)}****`
                  : ""
              }${
                this.receiverMobile2
                  ? ` /${this.receiverMobile2.slice(0, -4)}****`
                  : ""
              }`;
            } else {
              return `${this.receiverMobile}${
                this.receiverMobile2 ? ` /${this.receiverMobile2}` : ""
              }`;
            }
        }
    }
  }

  get displayReceiverName() {
    switch (this.sizeType) {
      default:
        switch (this.spotCode) {
          case SPOT_CODE_10128:
          case SPOT_CODE_10129:
          case SPOT_CODE_10130:
          case SPOT_CODE_10220:
          case SPOT_CODE_10212:
          case SPOT_CODE_10282:
          case SPOT_CODE_10279:
          case SPOT_CODE_10240:
          case SPOT_CODE_10063:
          case SPOT_CODE_10506:
          case SPOT_CODE_10491:
          case SPOT_CODE_10546:
            return `${(this.receiverName || "").slice(0, -1)}*`;
          case SPOT_CODE_10480:
          case SPOT_CODE_10517:
            return `${(this.receiverName || "").slice(0, 1)}*${(
              this.receiverName || ""
            )
              .slice(2)
              .trim()}`;
          default:
            if (this.useMasking) {
              return `${(this.receiverName || "").slice(0, 1)}*${(
                this.receiverName || ""
              )
                .slice(2)
                .trim()}`;
            } else {
              return this.receiverName;
            }
        }
    }
  }

  get displayUnrefinedAddress() {
    const _unrefinedAddress = (
      this.unrefinedAddress ||
      `${this.customerAddress || ""} ${this.customerAddressDetail || ""}`
    ).trim();

    switch (this.spotCode) {
      case SPOT_CODE_10480:
      case SPOT_CODE_10517:
        if (
          this.addressNotSupported ||
          this.status === DELIVERY_STATUS_9 ||
          !!this.customerAddressError
        ) {
          return `${
            this.receiverAddressObj
              ? _unrefinedAddress
              : _unrefinedAddress.slice(0, -10) + "**********"
          } ${this.etc4Obj.customerAddressEng || ""}`.trim();
        } else {
          return "";
        }
      default:
        if (this.useMasking) {
          if (this.receiverAddressObj) {
            return "";
          } else {
            return _unrefinedAddress.slice(0, -10) + "**********";
          }
        } else {
          return _unrefinedAddress;
        }
    }
  }

  get displaySenderAddress() {
    switch (this.spotCode) {
      case SPOT_CODE_10480:
      case SPOT_CODE_10517:
      case SPOT_CODE_10546:
        return (
          (this.senderAddressRoad?.split(" ").slice(0, 2).join(" ") || "") +
          "***"
        );
      default:
        return this.senderAddressRoad;
    }
  }

  get displaySenderAddressDetail() {
    switch (this.spotCode) {
      case SPOT_CODE_10480:
      case SPOT_CODE_10517:
      case SPOT_CODE_10546:
        return "";
      default:
        if (this.senderAddressError) {
          return this.senderInputAddress || this.senderAddress;
        } else if (
          this.senderAddressDetail &&
          this.senderAddressDetail.indexOf(this.senderAddress) > -1
        ) {
          return this.senderAddressDetail.slice(this.senderAddress.length);
        } else {
          return this.senderAddressDetail;
        }
    }
  }

  get displaySenderMobile() {
    const senderMobile = this.senderMobile;

    return `${senderMobile}`;

    // switch (this.sizeType) {
    //   case SIZE_TYPE_200:
    //     return `${
    //       senderMobile
    //         ? `${senderMobile.slice(0, 3)}****${senderMobile.slice(7)}`
    //         : ""
    //     }`;
    //   default:
    //     switch (this.spotCode) {
    //       case SPOT_CODE_10128:
    //       case SPOT_CODE_10129:
    //       case SPOT_CODE_10130:
    //       case SPOT_CODE_10220:
    //       case SPOT_CODE_10212:
    //       case SPOT_CODE_10282:
    //       case SPOT_CODE_10279:
    //       case SPOT_CODE_10240:
    //       case SPOT_CODE_10063:
    //       case SPOT_CODE_10506:
    //       case SPOT_CODE_10491:
    //       case SPOT_CODE_10480:
    //       case SPOT_CODE_10517:
    //       case SPOT_CODE_10546:
    //         return `${senderMobile ? `${senderMobile.slice(0, -4)}****` : ""}`;
    //       default:
    //         return `${senderMobile}`;
    //     }
    // }
  }

  get displaySenderName() {
    let senderName = this.senderName;

    switch (this.spotCode) {
      case SPOT_CODE_10480:
      case SPOT_CODE_10517:
      case SPOT_CODE_10546:
        return `${(senderName || "").slice(0, 1)}*${(senderName || "")
          .slice(2)
          .trim()}`;
      default:
        return senderName;
    }
  }

  get dongCode() {
    const addressNotSupported =
      this.addressNotSupported || this.status === DELIVERY_STATUS_9;

    switch (this.sizeType) {
      case SIZE_TYPE_150_HANJIN:
      case SIZE_TYPE_150_V3:
      case SIZE_TYPE_150_V3_BLANK:
        if (this.type === DELIVERY_TYPE_NORMAL) {
          return {
            returnPickup: "",
            sidodong: `${
              this.receiverSidoName ? this.receiverSidoName.slice(0, 2) : ""
            }-${
              this.receiverDongName ? this.receiverDongName.slice(0, 2) : ""
            }-`,
            allocationGroup: addressNotSupported
              ? "불가지역"
              : this.receiverAllocationGroupNameCache || "(미지정)",
          };
        } else {
          return {
            returnPickup:
              this.type === DELIVERY_TYPE_RETURN
                ? this.returningBack
                  ? "회송-"
                  : "반품-"
                : "픽업-",
            sidodong: "",
            allocationGroup: addressNotSupported
              ? "불가지역"
              : this.senderAllocationGroupNameCache || "(미지정)",
          };
        }

      default:
        return `${
          this.receiverSidoName ? this.receiverSidoName.slice(0, 2) : ""
        }-${
          addressNotSupported
            ? "불가지역"
            : this.receiverAllocationGroupNameCache || "(미지정)"
        }-${this.receiverDongName ? this.receiverDongName.slice(0, 2) : ""}`;
    }
  }

  get etc4Obj() {
    try {
      return this.etc4 && JSON.parse(this.etc4);
    } catch (e) {
      return {};
    }
  }

  get _productNameStyleOptions() {
    const isBig =
      this.delivery?.isSpotKukka || this.delivery?.isSpotDialCommunication;
    return {
      fontSize: isBig ? 17 : 12,
      fontWeight: "bold",
      widthMm: 78,
    };
  }

  get _splitProductNames() {
    if (!this.productObj || !this.productObj.productNamesArr.length) {
      return { first: [], rest: [] };
    }
    return splitProductNamesByLines(
      this.productObj.productNamesArr,
      this.numOfLinesFirstProductNames,
      this._productNameStyleOptions,
    );
  }

  get firstProductNames() {
    return this._splitProductNames.first;
  }

  get restProductNames() {
    return this._splitProductNames.rest;
  }

  get gatheredDeliveries() {
    return this.etc4Obj?.gatheredDeliveries || [];
  }

  get isPickupReturn() {
    return (
      this.type === DELIVERY_TYPE_RETURN || this.type === DELIVERY_TYPE_PICKUP
    );
  }

  get numOfCharactersProductNames() {
    switch (this.sizeType) {
      case SIZE_TYPE_150_HANJIN:
      case SIZE_TYPE_150_V3:
      case SIZE_TYPE_150_V3_BLANK:
        return 20;
      default:
        return 20;
    }
  }

  get numOfLinesRestProductNames() {
    switch (this.sizeType) {
      case SIZE_TYPE_150_HANJIN:
      case SIZE_TYPE_150_V3:
      case SIZE_TYPE_150_V3_BLANK:
        return 18;
      default:
        return 22;
    }
  }

  get numOfLinesFirstProductNames() {
    switch (this.sizeType) {
      case SIZE_TYPE_150_HANJIN:
      case SIZE_TYPE_150_V3:
      case SIZE_TYPE_150_V3_BLANK:
        return 12;
      default:
        return 18;
    }
  }

  get productObj() {
    if (this.totalProductName) {
      return splitProductNames(this.spotCode, this.totalProductName, {
        lineLength: this.numOfCharactersProductNames,
        postfix: this.postFixBySpotCode,
        targetSymbol: this.targetSymbolBySpotCode,
      });
    } else {
      return null;
    }

    // productNamesArr = splitResult.productNamesArr;
    // gatheredCount = splitResult.productTypeCount;
  }

  get productCount() {
    return this.etc4Obj?.productCount || this.productCountOld;
  }

  get isSpotKukka() {
    return this.spotCode === SPOT_CODE_82005;
  }

  get isSpotDialCommunication() {
    return this.spotCode === SPOT_CODE_82002;
  }

  get isSpotUgleelab() {
    return this.spotCode === SPOT_CODE_10715;
  }

  get isSpotCovering() {
    return this.spotCode === SPOT_CODE_10558;
  }

  get isSpotDduckhamji() {
    return this.spotCode === SPOT_CODE_10278;
  }

  get postFixBySpotCode() {
    switch (this.spotCode) {
      case SPOT_CODE_10190:
      case SPOT_CODE_10569:
      case SPOT_CODE_10695:
        return this.etc2 ? ` (${maskEtc2(this.etc2)})` : "";
      case SPOT_CODE_10241:
      case SPOT_CODE_10644:
      case SPOT_CODE_10643:
      case SPOT_CODE_10063:
        return this.etc2 ? ` (${this.etc2})` : "";
      default:
        return "";
    }
  }

  get receiverAllocationGroupNameCache() {
    let receiverAllocationGroupNameCache = this.receiverAllocationGroupName;

    return receiverAllocationGroupNameCache;
  }

  get receiverAddressWithoutSigungu() {
    return this.receiverAddress
      ? this.receiverAddress.split(" ").slice(2).join(" ")
      : "";
  }

  get receiverAddressRoadWithoutSigungu() {
    return this.receiverAddressRoad
      ? this.receiverAddressRoad.split(" ").slice(2).join(" ")
      : "";
  }

  get receiverAddressObj() {
    return this.etc4Obj ? this.etc4Obj.receiverAddressObj : null;
  }

  get receiverBuilding() {
    return this.etc4Obj && this.etc4Obj.receiverBuilding;
  }

  get receiverDongName() {
    return this.receiverDong ? this.receiverDong.name : "";
  }

  get receiverSigunguName() {
    return this.receiverSigungu ? this.receiverSigungu.name : "";
  }

  get receiverSidoName() {
    return this.receiverSido ? this.receiverSido.name : "";
  }

  get returningBack() {
    if (this.etc4Obj) {
      return !!this.etc4Obj.returningBack;
    } else {
      return false;
    }
  }

  // 반품/픽업의 경우 이전 수하인 주소 표기를 위함
  get returnPickupEtc4Obj() {
    try {
      return this.etc4Obj.etc4 && JSON.parse(this.etc4Obj.etc4);
    } catch (e) {
      return {};
    }
  }

  get senderAddressWithoutSigungu() {
    return this.senderAddress
      ? this.senderAddress.split(" ").slice(2).join(" ")
      : "";
  }

  get senderAllocationGroupNameCache() {
    let senderAllocationGroupNameCache = this.senderAllocationGroupName;

    return senderAllocationGroupNameCache;
  }

  get senderAddressRoadWithoutSigungu() {
    return this.senderAddressRoad
      ? this.senderAddressRoad.split(" ").slice(2).join(" ")
      : "";
  }

  get senderBuilding() {
    return this.etc4Obj && this.etc4Obj.senderBuilding;
  }

  get barcodeTitleBySpotCode() {
    switch (this.sizeType) {
      case SIZE_TYPE_150_HANJIN:
      case SIZE_TYPE_150_V3:
      case SIZE_TYPE_150_V3_BLANK:
        switch (this.spotCode) {
          case SPOT_CODE_10128:
          case SPOT_CODE_10129:
          case SPOT_CODE_10130:
          case SPOT_CODE_10220:
            return "CJ 코드";
          default:
            return null;
        }
      default:
        return null;
    }
  }

  get barcodeCodeBySpotCode() {
    switch (this.sizeType) {
      case SIZE_TYPE_150_HANJIN:
      case SIZE_TYPE_150_V3:
      case SIZE_TYPE_150_V3_BLANK:
        switch (this.spotCode) {
          case SPOT_CODE_10128:
          case SPOT_CODE_10129:
          case SPOT_CODE_10130:
          case SPOT_CODE_10220:
            return this.etc4Obj && this.etc4Obj.shippingNumber;
          case SPOT_CODE_10209:
          case SPOT_CODE_10276:
            return this.etc4Obj && this.etc4Obj.barcode;
          case SPOT_CODE_10585:
            return this.orderIdFromCorp;
          default:
            return null;
        }
      default:
        return null;
    }
  }

  get spotCode() {
    return this.spot ? this.spot.code : null;
  }

  get spotName() {
    return this.spot ? this.spot.name : null;
  }

  get spotContactForLabel() {
    return this.spot && this.spot.contactForLabel;
  }

  get targetSymbolBySpotCode() {
    switch (this.spotCode) {
      // case SPOT_CODE_10101:
      //   return ":|";
      // case SPOT_CODE_10184:
      //   return "$";
      // case SPOT_CODE_10191:
      // case SPOT_CODE_10195:
      // case SPOT_CODE_10196:
      // case SPOT_CODE_10197:
      // case SPOT_CODE_10198:
      //   return ";";
      default:
        return ";;";
    }
  }

  get totalProductPage() {
    return Math.ceil(
      (this.productObj ? this.productObj.productTypeCount : 0) /
        this.numOfLinesRestProductNames,
    );
  }

  get totalProductName() {
    let productNames = [];

    if (this.productName) {
      let _productName = `${this.productName}${
        this.productCount ? ` [${this.productCount}개]` : ""
      }`;
      productNames.push(_productName);
    }

    if (this.gatheredDeliveries.length > 0) {
      this.gatheredDeliveries.forEach((delivery) => {
        let _productName = `${delivery.productName}${
          delivery.productCount ? ` [${delivery.productCount}개]` : ""
        }`;
        productNames.push(_productName);
      });
    }

    return productNames.join(";;");
  }

  get totalQuantity() {
    let quantity = 0;

    if (this.productCount) {
      quantity += Number(this.productCount);
    }

    if (this.gatheredDeliveries.length > 0) {
      this.gatheredDeliveries.forEach((d) => {
        quantity += Number(d.productCount);
      });
    }

    return quantity;
  }

  get useMasking() {
    return !!this.corpUserEtcObj?.useMasking || false;
  }

  renderNumbering(count = 1, totalCount = 1) {
    switch (this.spotCode) {
      case SPOT_CODE_10276:
        return null;
      default:
        return `${count}/${totalCount}`;
    }
  }

  renderTotalProductCount() {
    return `${this.productObj ? this.productObj.productTypeCount : 0}건${
      this.totalQuantity ? `(${this.totalQuantity}개)` : ""
    }`;
  }

  renderReceiptDate(dateFormat = "yyyy/MM/dd HH:mm") {
    return (
      this.receiptDate &&
      formatDate(getDateByTimeZone(this.receiptDate), dateFormat)
    );
  }

  /** 한진 운송장 관련 */
  get hanjinCodSeq() {
    return this.etc4Obj?.HANJIN_COD_SEQ;
  }

  get hanjinCusNum() {
    return this.etc4Obj?.HANJIN_CUS_NUM;
  }
  get hanjinDlvDiv() {
    return this.etc4Obj?.HANJIN_DLV_DIV;
  }
  get hanjinOrdNum() {
    return this.etc4Obj?.HANJIN_ORD_NUM;
  }
  get hanjinPrintWbl() {
    return this.etc4Obj?.HANJIN_PRINT_WBL;
  }
  get hanjinPrintWblAt() {
    return this.etc4Obj?.HANJIN_PRINT_WBL_AT;
  }
  get hanjinSvcDiv() {
    return this.etc4Obj?.HANJIN_SVC_DIV;
  }
  get hanjinBoxType() {
    return this.etc4Obj?.boxType;
  }

  get hanjinPrintWblCenCod() {
    return this.hanjinPrintWbl?.cen_cod;
  }
  get hanjinPrintWblCenNam() {
    return this.hanjinPrintWbl?.cen_nam;
  }
  get hanjinPrintWblDlvTyp() {
    return this.hanjinPrintWbl?.dlv_typ;
  }
  get hanjinPrintWblDomMid() {
    return this.hanjinPrintWbl?.dom_mid;
  }
  get hanjinPrintWblDomRgn() {
    return this.hanjinPrintWbl?.dom_rgn;
  }
  get hanjinPrintWblEsCod() {
    return this.hanjinPrintWbl?.es_cod;
  }
  get hanjinPrintWblEsNam() {
    return this.hanjinPrintWbl?.es_nam;
  }
  get hanjinPrintWblGrpRnk() {
    return this.hanjinPrintWbl?.grp_rnk;
  }
  get hanjinPrintWblHubCod() {
    return this.hanjinPrintWbl?.hub_cod;
  }
  get hanjinPrintWblTmlCod() {
    return this.hanjinPrintWbl?.tml_cod;
  }
  get hanjinPrintWblMsgKey() {
    return this.hanjinPrintWbl?.msg_key;
  }
  get hanjinPrintWblPdTim() {
    return this.hanjinPrintWbl?.pd_tim;
  }
  get hanjinPrintWblPrtAdd() {
    return this.hanjinPrintWbl?.prt_add;
  }
  get hanjinPrintWblPtnSrt() {
    return this.hanjinPrintWbl?.ptn_srt;
  }
  get hanjinPrintWblResultCode() {
    return this.hanjinPrintWbl?.result_code;
  }
  get hanjinPrintWblResultMessage() {
    return this.hanjinPrintWbl?.result_message;
  }
  get hanjinPrintWblStmlCod() {
    return this.hanjinPrintWbl?.s_tml_cod;
  }
  get hanjinPrintWblStmlNam() {
    return this.hanjinPrintWbl?.s_tml_nam;
  }
  get hanjinPrintWblSvcNam() {
    return this.hanjinPrintWbl?.svc_nam;
  }
  get hanjinPrintWblSrtNam() {
    return this.hanjinPrintWbl?.srt_nam;
  }
  get hanjinPrintWblZipCod() {
    return this.hanjinPrintWbl?.zip_cod;
  }
}

const maskEtc2 = (value) => {
  if (value.length < 8) {
    // 8자리 미만: 앞 2자리만 마스킹
    return "*".repeat(2) + value.slice(2);
  }
  // 8자리 이상: 앞 2자리 + 마스킹 + 뒤 6자리
  const prefix = value.slice(0, 2);
  const suffix = value.slice(-6);
  const maskedLength = value.length - 2 - 6;
  return prefix + "*".repeat(maskedLength) + suffix;
};

const splitProductNames = (
  spotCode,
  productNamesStr,
  { lineLength = 21, postfix = "", prefix = "●", targetSymbol = "" },
) => {
  let productTypeCount = 0;
  let productNamesArr = [];

  if (targetSymbol) {
    productNamesArr = productNamesStr
      .split(targetSymbol)
      .filter((p) => !!p.trim());
    productTypeCount = productNamesArr.length;
  } else {
    productNamesArr = [productNamesStr];
    productTypeCount = 1;
  }

  return {
    productNamesArr: productNamesArr
      .filter((p) => p.trim())
      .map((p) => {
        if (spotCode === SPOT_CODE_10580) {
          if (p.includes("옵션")) {
            return `${prefix}${p}${postfix}`;
          } else {
            const firstOpenBracket = p.indexOf("(");

            if (firstOpenBracket !== -1) {
              const bracketContent = p.substring(firstOpenBracket);
              return `${prefix}${bracketContent}${postfix}`;
            } else {
              return `${prefix}${p}${postfix}`;
            }
          }
        }

        return `${prefix}${p}${postfix}`;
      })
      .map((p) => splitProductNameByKr(p, lineLength)),
    productTypeCount,
  };
};

function splitProductNameByKr(productName, length) {
  const krRegex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g;
  const enCapitalRegex = /[A-Z]/g;

  const etcLength = productName
    .replace(krRegex, "")
    .replace(enCapitalRegex, "").length;
  const enCapitalLength = productName.replace(krRegex, "").length - etcLength;
  const krLength = productName.length - enCapitalLength - etcLength;

  if (krLength + enCapitalLength * 0.8 + etcLength * 0.6 <= length) {
    return productName;
  }

  const productNames = [];
  let count = 0;
  let splittedProductName = "";
  for (let i = 0; i < productName.length; i++) {
    let nextCount = 0;
    if (krRegex.test(productName[i])) {
      nextCount = 1;
    } else if (enCapitalRegex.test(productName[i])) {
      nextCount = 0.8;
    } else {
      nextCount = 0.6;
    }

    if (count + nextCount > length) {
      productNames.push(splittedProductName);
      splittedProductName = "";
      count = 0;
    } else {
      count += nextCount;
    }

    splittedProductName = `${splittedProductName}${productName[i]}`;

    if (i === productName.length - 1) {
      productNames.push(splittedProductName);
      splittedProductName = "";
      count = 0;
    }
  }

  return productNames;
}
